import React from 'react';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import Pager from 'components/Pager';

import Button from '@material-ui/core/Button';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import FormHelperText from '@material-ui/core/FormHelperText';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';

import axios from 'axios';
import Qs from 'qs';
import Conf from 'utils/Conf';
import {Trans, withTranslation} from 'react-i18next';
import Context from 'utils/Context';
class RegisterPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      passwordConfirm: '',
      errors: {},
      infosIdx: 0,
      user: {
        firstname: '',
        lastname: '',
        pseudo: '',
        email: this.props.initEmail || '',
        password: '',
        latitude: null,
        longitude: null,
        newsletter: 1,
      },
      activeStep: 0,
      submitted: false,
      validations: {formLocali: null, formInfos: null, formLogins: null},
    };
  }
  handleChange = event => {
    let {name, value, type} = event.target;
    const {user} = this.state;
    if (name === 'passwordConfirm') {
      this.setState({
        passwordConfirm: value,
      });
      if (value === this.state.user.password) this.setError('passwordConfirm', '');
      return;
    }
    if (name === 'password') {
      if (value.length >= 5) this.setError('password', '');
      if (value === this.state.passwordConfirm) this.setError('passwordConfirm', '');
    }
    if (name === 'email') {
      this.setError('email', '');
    }
    if (type === 'checkbox') value = event.target.checked ? 1 : 0;
    this.setState({
      user: {
        ...user,
        [name]: value,
      },
    });
  };
  setError = (name, value) => {
    const errors = this.state.errors;
    this.setState({
      errors: {
        ...errors,
        [name]: value,
      },
    });
  };
  handleSubmit = event => {
    event.preventDefault();
    let {name} = event.target;
    const {geoloc, methods, appState} = this.context;
    const {user} = this.state;

    const shouldShowNewsletterCheckbox = appState.conf.NEWSLETTER_ENABLED;
    this.setState({
      errors: {},
    });
    switch (name) {
      case 'formInfos':
        methods.updateProfile(
          {
            ...user,
            newsletter: !!shouldShowNewsletterCheckbox && user.newsletter,
          },
          () => {
            if (geoloc) this.nextStep();
            else this.setState({infosIdx: 1});
          },
        );
        break;
      case 'formLogins':
        this.register(user);
        break;
      default:
        break;
    }
  };
  register = user => {
    const data = {...user, lang: this.props.i18n.language};
    const {methods} = this.context;
    return axios.post(Conf.apiBaseUriLegacy + '/user/register', Qs.stringify(data), {withCredentials: true}).then(response => {
      const data = response.data;
      if (data.status === 'success') {
        methods.getProfile();
        this.nextStep();
      } else if (data.status === 'error') {
        this.setError('register', data.error);
      }
    });
  };
  mailCheck = e => {
    const {t} = this.props;
    const {methods} = this.context;
    var value = e.target.value;
    methods.mailCheck(value, val => {
      if (val) this.setError('email', t('un-utilisateur-est-deja-inscrit-avec-cette-adresse-email'));
      else this.setError('email', '');
    });
  };
  checkPassword = e => {
    const {t} = this.props;
    if (this.state.user.password.length < 5)
      this.setError('password', t('le-mot-de-passe-doit-comporter-au-moins-5-caracteres'));
    else this.setError('password', '');
  };
  checkPasswords = e => {
    const {t} = this.props;
    if (this.state.passwordConfirm !== this.state.user.password)
      this.setError('passwordConfirm', t('les-mots-de-passe-ne-correspondent-pas'));
    else this.setError('passwordConfirm', '');
  };
  handleNext = event => {
    this.nextStep();
  };
  nextStep = () => {
    if (this.state.activeStep === 1 && this.props.onLogin) {
      this.props.onClose();
      this.props.onLogin();
    } else {
      this.setState({activeStep: this.state.activeStep + 1});
    }
  };
  render() {
    const {activeStep, user, errors} = this.state;
    const {t, onClose} = this.props;
    const {appState} = this.context;

    const shouldShowNewsletterCheckbox = appState.conf.NEWSLETTER_ENABLED;
    const pages = [
      <form name="formLogins" onSubmit={this.handleSubmit}>
        <DialogContent>
          <TextField
            label={t('e-mail')}
            name="email"
            variant="filled"
            margin="dense"
            fullWidth
            value={user.email}
            onBlur={this.mailCheck}
            onChange={this.handleChange}
            error={Boolean(errors.email)}
            helperText={errors.email ? errors.email : ''}
          />
          <TextField
            label={t('mot-de-passe')}
            name="password"
            type="password"
            variant="filled"
            margin="dense"
            fullWidth
            value={user.password}
            onBlur={this.checkPassword}
            onChange={this.handleChange}
            error={Boolean(errors.password)}
            helperText={errors.password ? errors.password : t('5-caracteres-minimum')}
          />
          <TextField
            label={t('confirmation-du-mot-de-passe')}
            name="passwordConfirm"
            variant="filled"
            type="password"
            margin="dense"
            fullWidth
            value={this.state.passwordConfirm}
            onChange={this.handleChange}
            onBlur={this.checkPasswords}
            error={Boolean(errors.passwordConfirm)}
            helperText={errors.passwordConfirm ? errors.passwordConfirm : ''}
          />
          {errors.register && <FormHelperText error>{errors.register}</FormHelperText>}
        </DialogContent>
        <DialogActions>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            className="btn btn-primary"
            disabled={
              this.state.user.email === '' ||
              this.state.user.password === '' ||
              Boolean(errors.email) ||
              Boolean(errors.passwordConfirm) ||
              Boolean(errors.password)
            }
          >
            {t('suivant')}
          </Button>
        </DialogActions>
      </form>,
      <form name="formInfos" onSubmit={this.handleSubmit} key="infosProfil">
        <DialogContent>
          <TextField
            fullWidth
            variant="filled"
            label={t('prenom')}
            name="firstname"
            margin="dense"
            value={user.firstname}
            onChange={this.handleChange}
          />
          <TextField
            fullWidth
            variant="filled"
            label={t('nom')}
            name="lastname"
            margin="dense"
            value={user.lastname}
            onChange={this.handleChange}
          />
          <TextField
            fullWidth
            variant="filled"
            label={`${t('pseudo')} *`}
            name="pseudo"
            margin="dense"
            value={user.pseudo}
            onChange={this.handleChange}
            helperText={errors.pseudo ? errors.pseudo : ''}
          />
          <div className="spacer"></div>
          {!!shouldShowNewsletterCheckbox && (
            <Grid container>
              <Grid item xs={2}>
                <Checkbox
                  checked={user.newsletter === 1}
                  onChange={this.handleChange}
                  name="newsletter"
                  inputProps={{'aria-label': 'primary Checkbox'}}
                  color="default"
                />
              </Grid>
              <Grid item xs={10}>
                {t('je-souhaite-etre-tenu-informe-des-actualites-de-la-vingt-cinquieme-heure')}
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" type="submit" disabled={this.state.user.pseudo === ''}>
            {t('enregistrer')}
          </Button>
        </DialogActions>
      </form>,
      <div>
        <DialogContent>
          <DialogContentText>{t('felicitations-votre-compte-a-ete-cree-avec-succes')}</DialogContentText>
          <DialogContentText>
            <Trans i18nKey="accedez-a-votre-compte-et-modifiez-vos-informations-en-cliquant-sur-licone">
              Accédez à votre compte et modifiez vos informations en cliquant sur l'icône{' '}
              <AccountCircleIcon className="register-text-icon" color="primary" /> en haut à droite de votre écran.
            </Trans>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" type="submit" onClick={onClose}>
            {t('fermer')}
          </Button>
        </DialogActions>
      </div>,
    ];
    return (
      <div>
        <DialogTitle>{t('inscription')}</DialogTitle>
        {activeStep <= 1 && (
          <div>
            {appState.screenSize !== 'xs' && (
              <Stepper alternativeLabel activeStep={activeStep}>
                <Step key="form1" completed={Boolean(false)}>
                  <StepLabel>{t('identifiants')}</StepLabel>
                </Step>
                <Step key="form2" completed={Boolean(false)} last={true}>
                  <StepLabel>{t('informations')}</StepLabel>
                </Step>
              </Stepper>
            )}
            {appState.screenSize === 'xs' && (
              <DialogContent>
                {activeStep === 0 && (
                  <Typography variant="h5" align="center">
                    1/2 {t('identifiants')}
                  </Typography>
                )}
                {activeStep === 1 && (
                  <Typography variant="h5" align="center">
                    2/2 {t('informations')}
                  </Typography>
                )}
              </DialogContent>
            )}
          </div>
        )}
        <Pager pages={pages} idx={activeStep} />
      </div>
    );
  }
}

RegisterPage.contextType = Context;

export default withTranslation()(RegisterPage);
